import "./styles.css";
import { useTranslation } from "react-i18next";

function LeadBadge(props) {
  const { t } = useTranslation();
  const { size } = props;
  return (
    <span className={`lead-badge${size === "large" ? " large" : ""}`}>
      {t("lead")}
    </span>
  );
}

export default LeadBadge;
